import React from "react";

const GooglePlay = ({ className = "", ...props }) => {
  return (
    <svg
      width="211"
      height="46"
      viewBox="0 0 211 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect width="211" height="46" rx="7.80223" fill="currentColor" />
      <path
        d="M79.3737 10.201C79.3737 11.2394 79.0567 12.0711 78.4321 12.6914C77.7141 13.4267 76.7788 13.7967 75.6328 13.7967C74.5375 13.7967 73.6022 13.4205 72.835 12.679C72.0662 11.9266 71.6826 11.0032 71.6826 9.89786C71.6826 8.79257 72.0662 7.86916 72.835 7.12297C73.6022 6.37523 74.5375 5.99902 75.6328 5.99902C76.1781 5.99902 76.698 6.1094 77.1941 6.3146C77.6887 6.52136 78.0913 6.80118 78.383 7.14629L77.7204 7.80231C77.2116 7.21314 76.5189 6.92243 75.6328 6.92243C74.8339 6.92243 74.1412 7.19603 73.5531 7.7479C72.9713 8.30133 72.6797 9.01798 72.6797 9.89786C72.6797 10.7777 72.9713 11.5006 73.5531 12.054C74.1412 12.5997 74.8339 12.8795 75.6328 12.8795C76.4808 12.8795 77.1941 12.5997 77.7569 12.0478C78.1278 11.6825 78.3386 11.1788 78.3941 10.5352H75.6328V9.63669H79.3166C79.361 9.83101 79.3737 10.0191 79.3737 10.201Z"
        fill="white"
        stroke="white"
        strokeWidth="0.156045"
        strokeMiterlimit="10"
      />
      <path
        d="M85.2173 7.08263H81.757V9.44556H84.8765V10.3441H81.757V12.707H85.2173V13.6227H80.7773V6.16699H85.2173V7.08263Z"
        fill="white"
        stroke="white"
        strokeWidth="0.156045"
        strokeMiterlimit="10"
      />
      <path
        d="M89.3404 13.6227H88.3608V7.08263H86.2383V6.16699H91.4645V7.08263H89.3404V13.6227Z"
        fill="white"
        stroke="white"
        strokeWidth="0.156045"
        strokeMiterlimit="10"
      />
      <path
        d="M95.2451 13.6227V6.16699H96.2231V13.6227H95.2451Z"
        fill="white"
        stroke="white"
        strokeWidth="0.156045"
        strokeMiterlimit="10"
      />
      <path
        d="M100.559 13.6227H99.5874V7.08263H97.457V6.16699H102.69V7.08263H100.559V13.6227Z"
        fill="white"
        stroke="white"
        strokeWidth="0.156045"
        strokeMiterlimit="10"
      />
      <path
        d="M112.581 12.6665C111.831 13.4205 110.903 13.7967 109.795 13.7967C108.68 13.7967 107.751 13.4205 107.002 12.6665C106.253 11.9141 105.881 10.9907 105.881 9.89786C105.881 8.805 106.253 7.88159 107.002 7.12919C107.751 6.37523 108.68 5.99902 109.795 5.99902C110.896 5.99902 111.825 6.37523 112.575 7.13541C113.329 7.89403 113.702 8.81122 113.702 9.89786C113.702 10.9907 113.329 11.9141 112.581 12.6665ZM107.726 12.0416C108.29 12.5997 108.977 12.8795 109.795 12.8795C110.606 12.8795 111.299 12.5997 111.857 12.0416C112.42 11.4835 112.705 10.7669 112.705 9.89786C112.705 9.02886 112.42 8.31221 111.857 7.75412C111.299 7.19604 110.606 6.91621 109.795 6.91621C108.977 6.91621 108.29 7.19604 107.726 7.75412C107.163 8.31221 106.878 9.02886 106.878 9.89786C106.878 10.7669 107.163 11.4835 107.726 12.0416Z"
        fill="white"
        stroke="white"
        strokeWidth="0.156045"
        strokeMiterlimit="10"
      />
      <path
        d="M115.076 13.6227V6.16699H116.265L119.962 11.9655H120.004L119.962 10.5322V6.16699H120.94V13.6227H119.919L116.048 7.53811H116.005L116.048 8.97763V13.6227H115.076Z"
        fill="white"
        stroke="white"
        strokeWidth="0.156045"
        strokeMiterlimit="10"
      />
      <path
        d="M105.641 24.51C102.663 24.51 100.23 26.7328 100.23 29.7995C100.23 32.8414 102.663 35.0874 105.641 35.0874C108.625 35.0874 111.058 32.8414 111.058 29.7995C111.058 26.7328 108.625 24.51 105.641 24.51ZM105.641 33.0046C104.007 33.0046 102.601 31.6818 102.601 29.7995C102.601 27.8923 104.007 26.5929 105.641 26.5929C107.275 26.5929 108.687 27.8923 108.687 29.7995C108.687 31.6818 107.275 33.0046 105.641 33.0046ZM93.8349 24.51C90.8504 24.51 88.4239 26.7328 88.4239 29.7995C88.4239 32.8414 90.8504 35.0874 93.8349 35.0874C96.8177 35.0874 99.2458 32.8414 99.2458 29.7995C99.2458 26.7328 96.8177 24.51 93.8349 24.51ZM93.8349 33.0046C92.1992 33.0046 90.7886 31.6818 90.7886 29.7995C90.7886 27.8923 92.1992 26.5929 93.8349 26.5929C95.4689 26.5929 96.8747 27.8923 96.8747 29.7995C96.8747 31.6818 95.4689 33.0046 93.8349 33.0046ZM79.7861 26.1312V28.3788H85.2588C85.0987 29.6347 84.6708 30.558 84.0147 31.2015C83.2159 31.9787 81.9717 32.8414 79.7861 32.8414C76.4181 32.8414 73.7808 30.1757 73.7808 26.8727C73.7808 23.5697 76.4181 20.904 79.7861 20.904C81.6072 20.904 82.9322 21.6019 83.9101 22.5065L85.5251 20.9226C84.1573 19.6418 82.3378 18.6579 79.7861 18.6579C75.1676 18.6579 71.2861 22.3433 71.2861 26.8727C71.2861 31.402 75.1676 35.0874 79.7861 35.0874C82.2823 35.0874 84.1573 34.2854 85.6313 32.7807C87.1417 31.2994 87.6124 29.2166 87.6124 27.5348C87.6124 27.0126 87.5681 26.5323 87.4888 26.1312H79.7861ZM137.233 27.8737C136.788 26.6908 135.414 24.51 132.615 24.51C129.841 24.51 127.532 26.6535 127.532 29.7995C127.532 32.7621 129.817 35.0874 132.881 35.0874C135.358 35.0874 136.788 33.6061 137.376 32.7434L135.537 31.5419C134.924 32.4217 134.089 33.0046 132.881 33.0046C131.681 33.0046 130.821 32.4652 130.269 31.402L137.482 28.4752L137.233 27.8737ZM129.879 29.6347C129.817 27.5954 131.494 26.5509 132.696 26.5509C133.637 26.5509 134.436 27.0126 134.702 27.6732L129.879 29.6347ZM124.017 34.7656H126.388V19.2222H124.017V34.7656ZM120.134 25.6882H120.054C119.522 25.0696 118.506 24.51 117.219 24.51C114.518 24.51 112.049 26.8354 112.049 29.8166C112.049 32.7807 114.518 35.0874 117.219 35.0874C118.506 35.0874 119.522 34.5232 120.054 33.8859H120.134V34.6444C120.134 36.6666 119.032 37.7531 117.255 37.7531C115.807 37.7531 114.908 36.7272 114.537 35.8646L112.475 36.7086C113.07 38.1106 114.643 39.8359 117.255 39.8359C120.035 39.8359 122.381 38.2318 122.381 34.3289V24.8318H120.134V25.6882ZM117.422 33.0046C115.788 33.0046 114.42 31.6632 114.42 29.8166C114.42 27.9529 115.788 26.5929 117.422 26.5929C119.032 26.5929 120.302 27.9529 120.302 29.8166C120.302 31.6632 119.032 33.0046 117.422 33.0046ZM148.334 19.2222H142.663V34.7656H145.028V28.8762H148.334C150.96 28.8762 153.536 27.0126 153.536 24.0484C153.536 21.0858 150.954 19.2222 148.334 19.2222ZM148.396 26.7141H145.028V21.3843H148.396C150.161 21.3843 151.17 22.822 151.17 24.0484C151.17 25.2515 150.161 26.7141 148.396 26.7141ZM163.014 24.4805C161.305 24.4805 159.528 25.2204 158.798 26.8602L160.896 27.7229C161.348 26.8602 162.178 26.5804 163.056 26.5804C164.283 26.5804 165.527 27.3032 165.546 28.5793V28.7425C165.118 28.5001 164.202 28.141 163.075 28.141C160.815 28.141 158.512 29.3612 158.512 31.6383C158.512 33.7211 160.364 35.0625 162.445 35.0625C164.036 35.0625 164.914 34.3584 165.466 33.5393H165.546V34.7408H167.83V28.7783C167.83 26.0224 165.732 24.4805 163.014 24.4805ZM162.728 32.9984C161.955 32.9984 160.877 32.6222 160.877 31.6818C160.877 30.4788 162.221 30.0171 163.385 30.0171C164.426 30.0171 164.914 30.2425 165.546 30.5394C165.361 31.9787 164.098 32.9984 162.728 32.9984ZM176.151 24.8209L173.433 31.559H173.352L170.542 24.8209H167.992L172.214 34.2372L169.805 39.4769H172.276L178.782 24.8209H176.151ZM154.835 34.7656H157.206V19.2222H154.835V34.7656Z"
        fill="white"
      />
      <path
        d="M32.4806 6.82546C32.1081 7.20783 31.8926 7.80315 31.8926 8.5741V36.0737C31.8926 36.8446 32.1081 37.4399 32.4806 37.8223L32.5725 37.9062L48.2854 22.5026V22.1389L32.5725 6.73531L32.4806 6.82546Z"
        fill="url(#paint0_linear_1895_23831)"
      />
      <path
        d="M53.517 27.6484L48.2852 22.5113V22.1476L53.5233 17.0105L53.6406 17.0773L59.844 20.5388C61.6144 21.5212 61.6144 23.1377 59.844 24.1263L53.6406 27.5816L53.517 27.6484Z"
        fill="url(#paint1_linear_1895_23831)"
      />
      <path
        d="M53.6408 27.5742L48.2853 22.3221L32.4805 37.8236C33.0685 38.4298 34.0274 38.5028 35.1178 37.8966L53.6408 27.5742Z"
        fill="url(#paint2_linear_1895_23831)"
      />
      <path
        d="M53.6408 17.076L35.1178 6.75354C34.0274 6.15356 33.0685 6.22662 32.4805 6.83281L48.2853 22.3281L53.6408 17.076Z"
        fill="url(#paint3_linear_1895_23831)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1895_23831"
          x1="46.8903"
          y1="36.36"
          x2="26.0257"
          y2="15.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1895_23831"
          x1="62.1493"
          y1="22.3277"
          x2="31.4691"
          y2="22.3277"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1895_23831"
          x1="50.7287"
          y1="19.4669"
          x2="22.4345"
          y2="-9.38379"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1895_23831"
          x1="28.5021"
          y1="46.9786"
          x2="41.1366"
          y2="34.0956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GooglePlay;
